<template>
  <div>
    <Head :title="title"/>

    <GlobalBanner />
    <Banner/>
    <SubscriptionBanners/>
    <div class="flex flex-col min-h-screen bg-white">

      <!-- Navbar -->
      <div class="sticky top-0 z-50" :class="navContainerClass">
        <Navigation
            :showing-navigation-dropdown="showingNavigationDropdown"
            :nav-class="navClass"
            @toggle-navigation-dropdown="toggleNavigationDropdown"
        />
      </div>

      <!-- Page Heading -->
      <header v-if="$slots.header" class="bg-green-100/10 w-full">
        <div :class="headerClass">
          <slot name="header"/>
        </div>
      </header>

      <!--  Header: sticky -->
      <!--  Content: grow overflow-y -->
      <!--  Flex global : min-h-screen -->

      <!-- Page Content -->
      <div class="grow">
        <div id="layout-container" :class="containerClass">
          <main>
            <slot/>
          </main>
        </div>
      </div>
      <!-- Page Footer -->
      <Footer class="mt-auto"/>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import {Head, router} from '@inertiajs/vue3';

import Footer from '@/Components/Client/Layouts/Footer.vue';
import Navigation from '@/Components/Client/Layouts/Navigation.vue';
import Banner from "@/Components/Banner.vue";
import GlobalBanner from "@/Components/GlobalBanner.vue";
import SubscriptionBanners from "@/Components/Subscription/SubscriptionBanners.vue";

defineProps({
  title: String,
  containerClass: {
    type: String,
    default: 'max-w-screen-3xl mx-auto px-4 sm:px-6 lg:px-12 p-1 md:p-10',
  },
  headerClass: {
    type: String,
    default: 'max-w-7xl mx-auto sm:px-6 lg:px-8 max-h-auto',
  },
  navClass: {
    type: String,
    default: 'max-w-screen-3xl mx-auto',
  },
  navContainerClass: {
    type: String,
    default: 'bg-white',
  },
});

const showingNavigationDropdown = ref(false);

const toggleNavigationDropdown = () => {
  showingNavigationDropdown.value = !showingNavigationDropdown.value;
};

const switchToTeam = (team) => {
  router.put(route('current-team.update'), {
    team_id: team.id,
  }, {
    preserveState: false,
  });
};

const logout = () => {
  router.post(route('logout'));
};
</script>